import { normalize, schema } from 'normalizr'
import { DAYS_OF_WEEK } from '../state/constants'
import { IWorkingHoursItem } from '../types'
import { serverApi } from '../utils/request'
import Paths from '../utils/paths'

class WorkingHoursService {
  private schemaServiceWorkingHours = new schema.Entity('serviceWorkingHours')

  public async fetchWorkingHours(serviceId: string): Promise<any> {
    const result = await serverApi.get(`${Paths.serviceDaysHoursBaseUrl}/${serviceId}`)

    const { entities } = normalize(result.data, [this.schemaServiceWorkingHours])
    if (!entities.serviceWorkingHours) {
      return {}
    }
    return entities.serviceWorkingHours
  }

  public updateWorkingHours(serviceId: string, workingHoursItems: IWorkingHoursItem[]): Promise<any> {
    console.log(workingHoursItems)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, 1000)
    })
  }

  public async removeServiceDaysHours(id: string) {
    const path = Paths.serviceDaysHours.baseWithId.replace(':id', id)
    return await serverApi.delete(path)
  }
}

const workingHoursService = new WorkingHoursService()

export { workingHoursService }



// WEBPACK FOOTER //
// ./src/services/WorkingHours.ts